import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitForm = (payload) =>
  axios.post(`${API}/submissions`, payload).then((r) => r.data);

export const createCheckout = (payload) =>
  axios.post(`${API}/payments/checkout`, payload).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);
